var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33.5C26.1127 33.5 33.5 26.1127 33.5 17C33.5 7.8873 26.1127 0.5 17 0.5C7.8873 0.5 0.5 7.8873 0.5 17C0.5 26.1127 7.8873 33.5 17 33.5Z",
    stroke: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1392 14.5989C22.1394 15.8125 21.7797 16.9988 21.1056 18.008C20.4316 19.0172 19.4734 19.8038 18.3523 20.2684C17.2311 20.733 15.9974 20.8547 14.8071 20.6182C13.6168 20.3816 12.5233 19.7974 11.6651 18.9394C10.8068 18.0814 10.2222 16.9881 9.98529 15.7979C9.74834 14.6077 9.86963 13.3739 10.3339 12.2526C10.7981 11.1314 11.5844 10.1729 12.5934 9.49852C13.6023 8.82413 14.7886 8.46406 16.0022 8.46387C17.6295 8.46387 19.1901 9.11017 20.341 10.2606C21.4918 11.4111 22.1387 12.9716 22.1392 14.5989Z",
    fill: "white",
    stroke: "#707070",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2098 19.1626L18.4912 20.5039L22.4125 25.5282L24.1311 24.1869L20.2098 19.1626Z",
    fill: "white",
    stroke: "#707070",
    strokeWidth: 0.999584
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.58923b2e60f96d45dd4bf82c97a7e1d4.svg";
export { ForwardRef as ReactComponent };